import type { IDropDownItem } from "@similarweb/ui-components";
import { CountryDropdownItem } from "@similarweb/ui-components";

import { omitReservedKey } from "app/pages/sales-intelligence/common-components/dropdown/utils/omitReservedKey";
import { StyledItemsDivider } from "app/pages/sales-intelligence/sub-modules/signals/components/styles";
import type { ICountryObject } from "app/services/CountryService";

type Props = IDropDownItem & {
    isFirstOfType: boolean;
    /*
	    preventDefault it is needed for the custom onClick to work
	    in the UI components dropdown
	*/
    preventDefault?: boolean;
    country: Readonly<ICountryObject>;
    onClick(event: MouseEvent): void;
};

const FilterCountryListItem = ({ country, isFirstOfType, onClick }: Props) => {
    return (
        <div>
            {isFirstOfType ? <StyledItemsDivider /> : null}
            <CountryDropdownItem
                key={country.id}
                {...omitReservedKey(country)}
                isClickAllowed
                onClick={onClick}
            />
        </div>
    );
};

export default FilterCountryListItem;
